import { render, staticRenderFns } from "./GSTPriceMaint.vue?vue&type=template&id=1225ce4a&scoped=true"
import script from "./GSTPriceMaint.vue?vue&type=script&lang=js"
export * from "./GSTPriceMaint.vue?vue&type=script&lang=js"
import style0 from "./GSTPriceMaint.vue?vue&type=style&index=0&id=1225ce4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225ce4a",
  null
  
)

export default component.exports